import React, { useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";
import Price from "../Misc/Price";

export default function GuaranteePriceField() {
  const {
    order,
    strings
  } = useContext(CarOrderingContext)

  const miscStrings = strings.misc ?? {}

  if (typeof order.guarantee_price !== 'number' || typeof order.guarantee_price_car !== 'string') {
    return null
  }

  return (
    <>
      <div className='config-overview__title'>
        <div>{miscStrings.guarantee_price_title}</div>
        <div>
          <div className='guarantee-price'>
            <div className='config-overview__title-price'>
              <Price price={order.guarantee_price}/>
            </div>
          </div>
        </div>
      </div>

      {typeof order?.guarantee_price_outstanding_debt === 'string' && order?.guarantee_price_outstanding_debt.length > 0 && (
        <div className="config-overview__price">
          <div>{miscStrings.outstanding_debt}</div>
          <div>
            <Price price={order.guarantee_price_outstanding_debt} />
          </div>
        </div>
      )}

      <div className="config-overview__price">
        <div>{miscStrings.model}</div>
        <div>{order.guarantee_price_car}</div>
      </div>
    </>
  )
}
